/* eslint-disable @typescript-eslint/ban-ts-comment */
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { ISelectValue } from 'constants/globalTypes'
import { getSingleWorkflow } from 'features/workflows/workflowsSlice'
import { workflowCriteriaList } from 'pages/Operations/Plans/plansData'
import React from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Flex, ItemsGrid, Separator, ThinSeparator } from 'styling/GlobalStyles'
import { BodyText } from 'styling/Typography'
import { IWorkflowsSingleResponse } from 'types/api/workflowsAPi.interface'
import { IPhaseState, IWorkflowBindingConfigState } from 'types/operationPlans.interface'

export const WorkflowTemplateType = ({ addingPhase, setAddingPhase }: { addingPhase: IPhaseState<IWorkflowBindingConfigState>, setAddingPhase: React.Dispatch<React.SetStateAction<IPhaseState<IWorkflowBindingConfigState>>> }) => {
    const dispatch = useDispatch<AppDispatch>()
    const parse = (data: any) => {
        return data ? data.data.map((item: any) => ({ label: item.name, value: item.id })) : []
    }

    const handleWorkflowSelect = async (value: ISelectValue) => {
        const resp = await dispatch(getSingleWorkflow(value.value))
        if (resp.meta.requestStatus === 'fulfilled') {
            // @ts-ignore 
            setAddingPhase(prev => ({
                ...prev, workflowTemplate: { label: value.label, value: value.value }, bindingConfig: {
                    startDate: null,
                    criteria: null,
                    department: null,
                    items: (resp.payload as IWorkflowsSingleResponse).items.map(item => ({
                        workflowTemplateItem: { label: item.taskTemplate.name, value: item.id },
                        location: null,
                        componentValues: item.taskTemplate.components.map(c => ({ taskComponent: { label: c.name, value: c.id }, value: null })),
                        // @ts-ignore
                        toolComponentValues: item.taskTemplate.toolTypeComponents.map(tc => ({ taskTemplateToolTypeComponent: { value: tc.id, label: tc.name }, toolComponent: { label: tc.toolTypeComponent, value: tc.toolTypeComponent.name }, amount: null }))
                    }))
                }
            }))
        }

    }

    const handleComponentValue = (e: React.ChangeEvent<HTMLInputElement>, itemIndex: number, componentIndex: number) => {
        const newValue = isNaN(e.target.valueAsNumber) ? null : e.target.valueAsNumber
        // @ts-ignore
        setAddingPhase(prev => ({
            ...prev,
            bindingConfig: {
                ...prev.bindingConfig,
                items: prev.bindingConfig.items.map((item, i) => i === itemIndex
                    ? { ...item, componentValues: item.componentValues.map((c, j) => j === componentIndex ? { ...c, value: newValue } : c) }
                    : item)
            }
        }))
    }

    const handleToolComponentValue = (e: React.ChangeEvent<HTMLInputElement>, itemIndex: number, componentIndex: number) => {
        const newValue = isNaN(e.target.valueAsNumber) ? null : e.target.valueAsNumber
        // @ts-ignore
        setAddingPhase(prev => ({
            ...prev,
            bindingConfig: {
                ...prev.bindingConfig,
                items: prev.bindingConfig.items.map((item, i) => i === itemIndex
                    ? { ...item, toolComponentValues: item.toolComponentValues.map((tc, j) => j === componentIndex ? { ...tc, amount: newValue } : tc) }
                    : item)
            }
        }))
    }

    const handleLocationChange = (value: ISelectValue, itemIndex: number) => {
        setAddingPhase(prev => ({
            ...prev,
            bindingConfig: {
                ...prev.bindingConfig,
                items: prev.bindingConfig.items.map((item, i) => i === itemIndex ? { ...item, location: value } : item)
            }
        }))
    }

    return <>
        <Flex column gap='1rem' >
            <HonestSelectAsyncInput
                keyProp={3}
                defaultValue={addingPhase.workflowTemplate?.label}
                link='workflow/template'
                labelText='Workflow Template'
                onChange={handleWorkflowSelect}
                name='workflowTemplate'
                placeholder='Search Workflow Templates'
                parserFunction={parse}
                required
                invalid={!addingPhase.workflowTemplate?.value}
            />
            {addingPhase.workflowTemplate?.value && <>
                <Flex gap='1rem' >
                    <CalendarInput
                        labelText='Start Date'
                        name='startDate'
                        onChange={date => setAddingPhase(prev => ({ ...prev, bindingConfig: { ...prev.bindingConfig, startDate: date } }))}
                        width='100%'
                    />
                    <HonestSelectInput name='criteria'
                        labelText='Criteria'
                        options={workflowCriteriaList}
                        // @ts-ignore
                        onChange={value => setAddingPhase(prev => ({ ...prev, bindingConfig: { ...prev.bindingConfig, criteria: value } }))}
                    />
                </Flex>

                <HonestSelectAsyncInput
                    link='departments'
                    placeholder='Search department'
                    name='department'
                    labelText='Department'
                    defaultValue={(addingPhase as IPhaseState<IWorkflowBindingConfigState>)?.bindingConfig?.department?.label}
                    onChange={value => setAddingPhase(prev => ({ ...prev, bindingConfig: { ...prev.bindingConfig, department: value } }))}
                    parserFunction={(data: any) =>
                        data.data.map((i: any) => ({ label: i.name, value: i.id }))
                    }
                />
                <Separator />
                {
                    (addingPhase as IPhaseState<IWorkflowBindingConfigState>)?.bindingConfig?.items.map((item, i) => <Flex column gap='1rem' key={i}>
                        <BodyText>{item.workflowTemplateItem?.label}</BodyText>
                        <HonestSelectAsyncInput
                            link='locations'
                            placeholder='Search locations'
                            name='location'
                            labelText='Location'
                            defaultValue={item.location?.label}
                            onChange={value => handleLocationChange(value, i)}
                            parserFunction={(data: any) => data.data.map((i: any) => ({ label: i.name, value: i.id }))}
                        />
                        <ItemsGrid columns={2} >
                            {item.componentValues.map((c, j) => <Input value={c.value ?? ''} key={j} width='100%' placeholder='Enter value' onChange={e => handleComponentValue(e, i, j)} labelText={c.taskComponent.label + ' value'} name='value' type='number' />)}
                        </ItemsGrid>
                        <ItemsGrid columns={2} >
                            {item.toolComponentValues.map((c, j) => <Input value={c.amount ?? ''} key={j} width='100%' placeholder='Enter value' onChange={e => handleToolComponentValue(e, i, j)} labelText={c.taskTemplateToolTypeComponent.label + ' value'} name='value' type='number' />)}
                        </ItemsGrid>
                        <ThinSeparator />
                    </Flex>)
                }

            </>}
        </Flex>

    </>
}
